"use strict";

import React from "react";

import {Checkbox} from "@/components/checkbox/Checkbox.js";
import {FieldErrors, FieldHelpText, uniqueHtmlId, unpackFormLinkOrProps} from "@/legacy/form/FormHelpers.jsx";

export default class CheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.htmlId = uniqueHtmlId(props.fieldName);
  }

  render() {
    const form = unpackFormLinkOrProps(this.props);

    return (
      <>
        <Checkbox
          className={this.props.divCSSClass}
          id={this.htmlId}
          name={form.fieldName}
          disabled={this.props.disabled}
          checked={form.value}
          onChange={form.onChange}
          helpText={this.props.titleText}
          label={this.props.labelText}
        />
        <FieldErrors errors={form.errors} />
        <FieldHelpText {...this.props} />
      </>
    );
  }
}

CheckBox.defaultProps = {
  fieldName: null, // Field name returned in form data
  labelText: null, // Label of this field
  titleText: null, // Tooltip
  helpText: null, // Help text beneath the field
  isRequired: false, // Field is required?
  disabled: false, // Control is disabled?

  divCSSClass: null, // Extra CSS classes to add to the div.form-check

  formLink: null, // Object from prepareFormLink() to auto-bind value, onChange, formErrors
  value: null, // React field value
  formErrors: null, // Dict of all form errors, possibly with an entry for fieldName

  onChange: null, // Change handler
};
